import React, {Component} from 'react';

import Avatar from '../Avatar';

import cl from 'classnames';
import s from './TestItemStatus.css';

class TestItemStatus extends Component {
  render() {
    const {className, isCompleted, size, icon} = this.props;

    return (
      <Avatar
        className={cl(s.Icon, className)}
        size={size}
        icon={React.cloneElement(icon, {
          customColor: isCompleted ? '#F0F0F0' : '#F7F7F7',
          ...icon.props
        })}
      />
    );
  }
}

export default TestItemStatus;
